import { LoadMethodOptions, Query } from '@cubejs-client/core';

export interface ICubeAdapter {
  query(
    token: string,
    data: Query,
    options?: LoadMethodOptions
  ): Promise<any[]>;
  getPoolStats?(): Record<string, any>;
  close?(): Promise<void>;
}
